// Overlay di scelta colore per la sfumatura: toni curati sopra, picker
// libero dell'app sotto. Vive DENTRO l'elemento del modal (host) così il
// focus resta nel modal e Bootstrap non lo reclama; l'Escape si ferma qui.

import $ from 'jquery';

const TONE_DOT = (tone) =>
  `<button type="button" class="ai-bgb-color-tone" data-tone="${tone.key}" title="${tone.label}">
     <span class="ai-bgb-sw ${tone.swatch}" style="background:${tone.tint}"></span>
     <span class="ai-bgb-color-tone-t">${tone.label}</span>
   </button>`;

const defaultMountPicker = async (container, { initialColor, onChange }) => {
  // Import a runtime come per l'anteprima: il peso del picker lo paga solo
  // chi apre l'overlay, e i test del builder restano montabili senza CSS.
  const { ColorPickerUI } = await import('~core/colorPicker/colorPickerUI.js');
  const picker = new ColorPickerUI(container, {
    mode: 'inline',
    format: 'hex',
    showAlpha: false,
    showQuickColors: true,
    showFavorites: true,
    showAdvanced: true,
    initialColor,
    onChange,
  });
  await picker.render();
  return picker;
};

export function openBuilderColorOverlay({
  host,
  title,
  tones,
  initial,
  // Tinta risolta corrente dell'estremo (quella già dipinta sul pallino):
  // senza un ref grezzo esplicito (eredità dalla palette) il picker deve
  // ripartire da qui, non dal bianco, altrimenti «Usa questo colore» senza
  // toccare nulla sposterebbe silenziosamente il colore verso il bianco.
  resolvedTint,
  onPick,
  mountPicker = defaultMountPicker,
}) {
  const initialColor =
    initial && initial.hex
      ? initial.hex
      : initial && initial.key
      ? (tones.find((tone) => tone.key === initial.key) || {}).tint || '#ffffff'
      : resolvedTint || '#ffffff';

  const $overlay = $(`
    <div class="ai-bgb-color-overlay" tabindex="-1">
      <div class="ai-bgb-color-overlay-backdrop"></div>
      <div class="ai-bgb-color-overlay-card">
        <div class="ai-bgb-color-overlay-t">${title}</div>
        <div class="ai-bgb-sublbl">Toni del builder</div>
        <div class="ai-bgb-color-tones">${tones.map(TONE_DOT).join('')}</div>
        <div class="ai-bgb-sublbl">Colore libero</div>
        <div class="ai-bgb-color-picker-mount"></div>
        <div class="ai-bgb-color-overlay-foot">
          <button type="button" class="btn btn-light ai-bgb-color-cancel">Annulla</button>
          <button type="button" class="btn ai-bgb-color-apply">Usa questo colore</button>
        </div>
      </div>
    </div>`);

  let liveHex = initialColor;
  let pickerInstance = null;
  let closed = false;

  const close = () => {
    if (closed) {
      return;
    }
    closed = true;
    if (pickerInstance && typeof pickerInstance.destroy === 'function') {
      pickerInstance.destroy();
    }
    $overlay.remove();
  };

  const pick = (ref) => {
    close();
    onPick(ref);
  };

  $overlay.on('click', '.ai-bgb-color-tone', function () {
    pick({ key: $(this).attr('data-tone') });
  });
  $overlay.on('click', '.ai-bgb-color-apply', () => {
    pick({ hex: String(liveHex).toLowerCase() });
  });
  $overlay.on('click', '.ai-bgb-color-cancel', close);
  $overlay.on('click', '.ai-bgb-color-overlay-backdrop', close);
  // L'Escape chiude solo l'overlay: stopPropagation impedisce al modal
  // Bootstrap sottostante (keydown sull'host) di chiudersi insieme.
  $overlay.on('keydown', (event) => {
    if (event.key === 'Escape') {
      event.stopPropagation();
      close();
    }
  });

  $(host).append($overlay);
  $overlay.trigger('focus');

  Promise.resolve(
    mountPicker($overlay.find('.ai-bgb-color-picker-mount')[0], {
      initialColor,
      onChange: (hex) => {
        liveHex = hex;
      },
    })
  ).then((instance) => {
    pickerInstance = instance;
    if (closed && instance && typeof instance.destroy === 'function') {
      instance.destroy();
    }
  });

  return { close };
}
